import "./GerberList.css";
import {observer} from "mobx-react-lite"
import {fileListStore} from "../../../stores/FileListStore"
import React, {useEffect} from "react";
import {FileUpload} from 'primereact/fileupload';
import {ListBox} from "primereact/listbox";
import {urls} from "../../../ApiUtils";

function GerberList() {
    const uploadUrl: string = urls.apiV1.upload.upload().url

    useEffect(() => {
        fileListStore.loadList()
    }, [])

    function handleFileNameClick(e: any) {
        fileListStore.selectByVal(e.value)
    }

    function onUpload(o: any) {
        const uploadedFileName = o.files[0].name
        fileListStore.loadList()
        fileListStore.selectByVal(uploadedFileName)
    }

    return (<>
        <div>
            <ListBox
                options={fileListStore.fileNames}
                onChange={handleFileNameClick}
                value={fileListStore.selected}
            ></ListBox>
        </div>

        <div className={"file-upload"}>
            <FileUpload mode="basic" name="file" url={uploadUrl} accept="zip/*" maxFileSize={10000000}
                        onUpload={onUpload}/>

        </div>
    </>)
}

export default observer(GerberList)
